<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="container-fluid">
        <div class="row" >
            <div class="col-12 mb-4">
                <v-card>
                    <v-card-title>
                        <v-btn @click="$router.go(-1)" outlined style="border: none;margin-right: 10px" title="Retour"><v-icon>mdi mdi-arrow-left</v-icon></v-btn>
                        {{$t('users.account_histories')}}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="mdi-magnify"
                                label="Search"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="histories"
                            :search="search"
                            sort-by="label"
                            class="elevation-1"
                            :loading="histories===undefined" loading-text="Chargement en cours...">
                        <template v-slot:item.suspended_by="{item}">
                            {{item.suspended_by._first_name+' '+item.suspended_by._last_name}}
                        </template>
                        <template v-slot:item._date="{item}">
                            {{ getDate(item._date)}}
                        </template>

                        <template v-slot:no-data>
                            {{$t('no_data')}}
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</template>

<script>
    /* eslint-disable */
    import {mapState} from "vuex";
    import * as Swal from "sweetalert2";
    import helpers from '../../mixins/helpers'
    import $ from 'jquery'

    $.fn.scrollToTop = function (speed) {
        if (typeof(speed) === 'undefined')
            speed = 1000;

        $('html, body').animate({
            scrollTop: parseInt($(this).offset().top)
        }, speed);
    };
    export default {
        label: "UserAccountHistory",
        mixins:[helpers(this)],
        data () {
            return {
                search: '',
                id:undefined,
                headers: [
                    {text: 'Raison', value: '_reason'},
                    {
                        text: 'Désactivé par',
                        align: 'start',
                        sortable: false,
                        value: 'suspended_by',
                    },
                    {text: 'Date', value: '_date'},
                ],
            }
        },
        computed: {
            ...mapState('users/',['histories'])
        },
        mounted(){
            $(window).scrollTop(0);
            if (this.$route.params.user_id){
                this.$store.dispatch('users/getUserAccountHistoriries',this.$route.params.user_id).then(()=>{
                });
            }

        },


        methods: {
            initialize () {
                this.langues = [
                    {
                        name:'Bénin',
                        code_iso_alpha_2:'BJ',
                        code_iso_alpha_3:'BEN',
                        code_iso_numerique:204
                    }
                ]
            },
            checkisDashboard(){
                this.$emit('checkisDashboard',true);
            },

        },
        created() {
            this.checkisDashboard();
            this.initialize()
        },

    }
</script>

<style scoped>

    h6{
        color: #1C3071;
        font-weight: 500;
    }
    .actions-inputs{
        display: inline-block;
        margin-right: 15px;
    }
    hr{
        margin-top: 0;
    }
</style>
